import { DashStackIcon } from "@mirage/mosaics/DCLWrappers/DashStackIcon";
import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import i18n from "@mirage/translations";
import { BaseResultRow } from "./BaseResultRow";

export const StackResultRow = (props: {
  scoredResult: typeahead.ScoredStack;
  isSelected: boolean;
}) => {
  const { scoredResult } = props;

  return (
    <BaseResultRow
      icon={
        <DashStackIcon
          colorIndex={scoredResult.result.stack_data?.color_index}
          emoji={scoredResult.result.stack_data?.emoji}
          size="medium"
          customColor={scoredResult.result.stack_data?.custom_color}
        />
      }
      title={
        scoredResult.result.stack_data?.name ||
        i18n.t("stacks_typeahead_default_title")
      }
      subtitle={i18n.t("stacks_typeahead_subtitle")}
    />
  );
};
